
import React from 'react';

const AuthUserContext = React.createContext({});

export { AuthUserContext };


// const { typeTeamRoleObject, setTypeTeamRoleObject } = useContext(AuthUserContext);